<!-- 会员等级变更日志 -->
<template>
    <c-dialog ref="upgradeRecordDialog" :title="title" width="1000" height="800" enable-flex :button="false">
        <c-table ref="upgradeRecordTable" height="770">
            <c-table-column label="调整类型" width="100" name="reward_type">
                <template v-slot="{data}">
                    <span v-if="data.upgrade_type==1">用户注册</span>
                    <span v-if="data.upgrade_type==2">总后台变更</span>
                    <span v-if="data.upgrade_type==3">付费开通代理</span>
                    <span v-if="data.upgrade_type==6">上级经销商调整</span>
                    <span v-if="data.upgrade_type==7">邀请保护期过期</span>
                </template>
            </c-table-column>
            <c-table-column label="调整前等级" name="pre_level_name" width="100"></c-table-column>
            <c-table-column label="调整后等级" name="upgrade_level_name" width="100"></c-table-column>
            <c-table-column label="调整前分享人" width="210">
                <template v-slot="{data}">
                    <div class="flex-center-cross">
                        <c-image :src="data.pre_share_user_head_photo" preview size="30" style="margin-right: 10px;"> </c-image>
                        <span v-if="data.pre_share_user_nick_name && data.pre_share_user_nick_name!=''">{{data.pre_share_user_nick_name}}</span>
                        <span v-else>--</span>
                        <span v-if="data.pre_share_user_phone">({{data.pre_share_user_phone}})</span>
                    </div>
                </template>
            </c-table-column>
            <c-table-column label="调整后分享人" width="210">
                <template v-slot="{data}">
                    <div class="flex-center-cross">
                        <c-image :src="data.upgrade_share_user_head_photo" preview size="30" style="margin-right: 10px;"> </c-image>
                        <span v-if="data.upgrade_share_user_nick_name && data.upgrade_share_user_nick_name!=''">{{data.upgrade_share_user_nick_name}}</span>
                        <span v-else>--</span>
                        <span v-if="data.upgrade_share_user_phone">({{data.upgrade_share_user_phone}})</span>
                    </div>
                </template>
            </c-table-column>
            <c-table-column label="备注" name="remark" width="300">
                <template v-slot="{data}">
                    <p v-if="data.remark" style="white-space: pre-wrap;">{{data.remark}}</p>
                    <p v-else>--</p>
                </template>
            </c-table-column>
            <c-table-column label="调整处理人" width="210">
                <template v-slot="{data}">
                    <div class="flex-center-cross" v-if="data.upgrade_type==2 || data.upgrade_type==6">
                        <c-image v-if="data.create_user_head_photo" :src="data.create_user_head_photo" preview size="30" style="margin-right: 10px;"> </c-image>
                        <span v-if="data.create_user_name && data.create_user_name!=''">{{data.create_user_name}}</span>
                        <span v-else>--</span>
                        <span v-if="data.create_user_phone">{{data.create_user_phone}}</span>
                    </div>
                    <div v-else>--</div>
                </template>
            </c-table-column>
            <c-table-column label="调整时间" name="create_date" width="155"></c-table-column>
        </c-table>
    </c-dialog>
</template>

<script>
	export default {
		props: {

        },

        data() {
            return {
                title:'会员调整记录',
                serachParams:{}
            }
        },
		
		methods: {
			open(params) {
                this.serachParams = params||{};
                if (params && params.title){
                    this.title = params.title;
                }
                this.$refs.upgradeRecordDialog.open();
                this.$refs.upgradeRecordTable.load({
                    url: '/member_user/upgrade/record/list',
                    data:this.serachParams
                });
			}
		}
	}
</script>